var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"card-servico m-0"},[_c('router-link',{staticClass:"front-card",attrs:{"tag":"div","to":_vm.link}},[_c('h4',{staticClass:"bold m-0 md-display-1 text-white tx-servico bold"},[_vm._v(_vm._s(_vm.titulo))])]),_c('div',{staticClass:"back-card",style:({
       backgroundImage: ("url('" + _vm.imgBg + "')"),
       backgroundPosition: 'center center',
       backgroundRepeat: 'no-repeat',
       backgroundSize: 'cover'
       })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }